import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

// components
import Scream from '../components/scream/Scream';
import ScreamSkeleton from '../util/ScreamSkeleton';

// redux stuff
import {connect} from 'react-redux';
import {getScreams} from '../redux/actions/dataActions';

class home extends Component {
  componentDidMount() {
    this.props.getScreams();
  }
  render() {
    // check if user is logged in
    const token = localStorage.FBIdToken;
    if (token) {
      const {screams, loading} = this.props.data;
      // if page is not loading show screams
      let recentScreamsMarkup = !loading ? (
        screams.map(scream => <Scream key={scream.screamId} scream={scream} />)
      ) : (
        <ScreamSkeleton />
      );
      return (
        <Grid container spacing={16}>
          {/* 12 is de totaal lengte van de content nu is het 2+8= 11 */}
          <Grid item sm={2} xs={12}>
            {/* <Profile /> */}
          </Grid>
          <Grid item sm={8} xs={12}>
            {recentScreamsMarkup}
          </Grid>
        </Grid>
      );
    } else {
      window.location.href = '/login';
    }
  }
}

home.propTypes = {
  getScreams: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.data
});

export default connect(mapStateToProps, {getScreams})(home);
